import { CircularProgress } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import useGlobalStyles from '../../../styles/globalStyles';

import SimpleImageLoader from '../../Atoms/SimpleImageLoader';
import SimpleMenu from '../../Atoms/SimpleMenu/SimpleMenu';
import useStyles from '../styles';
import ImageSelectionAndCropper from "../../Organisms/ImageSelectionAndCropper";
import {compressImage} from "../../Organisms/ImageSelectionAndCropper/utils/base64Resize";

interface IAlertUserProps {
    alertUser: {
        name: string;
        profileImage: string;
        profileImageThumbnail: string;
        loading: boolean;
    };
    saveAlertUserImage: Function;
    saveAlertUserName: Function;
    removeAlertUserAvatar: Function;
}

const AlertUser = ({ alertUser, removeAlertUserAvatar, saveAlertUserImage, saveAlertUserName }: IAlertUserProps) => {
    const [nameField, setNameField] = useState(alertUser.name || '');
    const [editing, setEditing] = useState(false);
    const globalClasses = useGlobalStyles();

    const classes = useStyles(editing);

    const handleSave = () => {
        saveAlertUserName(nameField);
        setEditing(false);
    };

    const handleChange = (evt: any) => {
        setNameField(evt.target.value);
    };

    const handleFileSelect = async (res: any) => {
        const base64 = res;
        const base64120 =  await compressImage(res, 120, 120)


        saveAlertUserImage({
            profileImage: base64,
            profileImage120: base64120,
        });
    };

    const AvatarSelector = () => (
        <ImageSelectionAndCropper
           handleFileSelection={handleFileSelect}
           recommended={{width:1024, height:1024}} aspectRatio={1024/1024}
           launchBrowserButtonText={'Change Profile Picture'}/>
    )


    const AvatarDisplay = (
        <Avatar aria-label="Recipe" className={classes.avatarWrapper}>
            {alertUser.profileImageThumbnail && (
                <SimpleImageLoader
                    alt={`${alertUser.name} profile thumbnail`}
                    className={classes.avatar}
                    src={alertUser.profileImageThumbnail}
                    width={60}
                />
            )}
        </Avatar>
    );
    useEffect(() => setNameField(alertUser.name), [alertUser]);

    return (
        <Card className={classes.card} data-cy="Dashboard-profile">
            <CardHeader
                action={
                    editing ? (
                        <Button
                            classes={{ root: classes.button }}
                            data-cy="Dashboard-profile-name-save"
                            onClick={handleSave}
                        >
                            Save
                        </Button>
                    ) : (
                        <SimpleMenu
                            className="Dashboard-profile"
                            mode="dark"
                            options={[
                                {
                                    callback: () => setEditing(true),
                                    label: 'Edit name',
                                },
                            ]}
                        />
                    )
                }
                avatar={alertUser.loading ? <CircularProgress /> : AvatarDisplay}
                classes={{
                    action: classes.action,
                    root: globalClasses.cardHeader,
                }}
                title={
                    <TextField
                        // id="outlined-name"
                        classes={{ root: classes.nameField }}
                        disabled={!editing}
                        margin="normal"
                        name="Dashboard-profile-name"
                        onChange={handleChange}
                        value={nameField || ''}
                    />
                }
            />
            <CardContent>
                {!alertUser.loading && alertUser.profileImage && (
                    <SimpleImageLoader
                        alt={`${alertUser.name} profile `}
                        className={classes.promptThumbnail}
                        options={{
                            removeButton: true,
                            handleRemove: () => {
                                removeAlertUserAvatar();
                            },
                            confirmationTitle: 'Remove avatar?',
                        }}
                        src={alertUser.profileImage}
                        width={150}
                    />
                )}
                {!alertUser.loading && <AvatarSelector />}
                {alertUser.loading && <CircularProgress />}

                <Typography color="textSecondary" component="p" variant="body2">
                    <br/>The above is the image that appears on moments you create, messages you send, and comments you post.
                </Typography>
            </CardContent>
        </Card>
    );
};

export default AlertUser;
